import { HttpService } from "@/core";



export class PurchaseAndMaterialReturnService {
  static useSimpleListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: `/purchase_receive_order/simpleNo/list`,
        params
      });
    return HttpService.useRequest<any>(api);
  }
  static getPutStorageDetail() {
    const api = (params) =>
      HttpService.axios({  
        url: "/storage_receipt/getPutStorageDetail",
        method: "GET",
        params,
      });
    return HttpService.usePagination<any>(api);
  }
}
